import React from "react"
import Layout from "../components/layout"
import SEO from "../components/bits/Seo"
import Showcase from "../components/sections/home/showcase"
import About from "../components/sections/home/about"
import Services from "../components/sections/home/services"
import Gallery from "../components/sections/home/gallery"
import Testimonials from "../components/sections/testimonials"
import { CateringMenu } from "../components/bits/Cta"
import Socials from "../components/sections/socials"
import Team from "../components/sections/team"
// =========================
// HOMEPAGE - Gloone Events
// =========================
const IndexPage = () => (
  <Layout>
    <SEO title="Gloone Events Planner & Catering Services" />
    <Showcase />
    <About />
    <Services />
    <Gallery />
    <Testimonials />
    <CateringMenu />
    <Team />
    <Socials />
  </Layout>
)

export default IndexPage
